import Vue from 'vue'
import App from './App.vue'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import store from './store'
import vueScrollto from 'vue-scrollto'
import router from './routes'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import './assets/reset.css';
import './assets/media.css';



Vue.component('loading-overlay',Loading)
new Vue({
  el : '#app',
  router,
  store : store,
  render: h => h(App)
})

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.use(vueScrollto)
